(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-login/assets/javascripts/react/jotai/iam-login-atoms.js') >= 0) return;  svs.modules.push('/modules/iam-login/assets/javascripts/react/jotai/iam-login-atoms.js');
"use strict";



const {
  atom,
  getDefaultStore
} = jotai;
const {
  loginType
} = svs.iam_login.data;
const deviceIsFreja = loginType === 'FREJA_EID';
const isPollingAtom = atom(false);
const qrCodeAtom = atom(false);
const activeMethodAtom = atom(deviceIsFreja ? svs.iam_login.constants.loginMethods.freja : svs.iam_login.constants.loginMethods.bankid);
const isNewCustomerAtom = atom(false);
const showLoaderAtom = atom(false);
const showFallbackAtom = atom(false);
const showFallbackQrAtom = atom(false);
const loginCompletedAtom = atom(false);
const store = getDefaultStore();
store.set(isPollingAtom, false);
store.set(loginCompletedAtom, false);
const loginAtoms = {
  isPollingAtom,
  activeMethodAtom,
  qrCodeAtom,
  isNewCustomerAtom,
  showLoaderAtom,
  showFallbackAtom,
  showFallbackQrAtom,
  loginCompletedAtom
};
svs.iam_login.atoms = loginAtoms;

 })(window);